import {loadFormAppJS} from 'app/components/formReference/loadFormAppJS';
import {appEvents} from 'app/utils/appEvents';
import {triggerCustomEvent} from 'app/utils/jqueryNative';
import {importJSI} from 'JSI/initJSI';

/**
 * Import gemComponents/JSI only if form-app or unrestricted-html are on the page.
 * This function must be called before executing checkModuleOnPage.run().
 * @param id
 * @param formAppPath
 */
export function importGemComponents(id?: string, formAppPath?: string) {
    if (!formAppPath && document.getElementsByClassName('unrestrictedHtml').length === 0) {
        return;
    }

    const callImport = async () => {
        try {
            if (formAppPath) {
                await loadFormAppJS(formAppPath);
            }

            await doImport();
            triggerCustomEvent(document, appEvents.jsiCompleted, id);
        } catch (err) {
            console.warn(err);
        }
    };

    if (id) {
        const onComponentInitializationCompleted: EventListener = (event: Event) => {
            const customEvent = event as CustomEvent;
            if (customEvent.detail && customEvent.detail !== id) {
                return;
            }

            document.removeEventListener(appEvents.initializationCompleted, onComponentInitializationCompleted);
            callImport();
        };

        document.addEventListener(appEvents.initializationCompleted, onComponentInitializationCompleted);
    } else {
        callImport();
    }
}

export async function doImport(): Promise<void> {
    if (window.GEM?.components && window.JSI?.components) {
        return;
    }

    const gemComponents = await import(/* webpackChunkName: "gemComponentsComponents" */ 'gemComponents/components');
    if (!window.GEM) {
        throw new ReferenceError('window.GEM is missing!');
    }

    window.GEM.components = gemComponents;

    if (!window.JSI) {
        throw new ReferenceError('window.JSI is missing!');
    }

    window.JSI.components = await importJSI();

    triggerCustomEvent(document, appEvents.jsInterfacesLoaded); // deprecated, but keep it working
}
